var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.775,
    y1: 0.086,
    x2: 0.148,
    y2: 0.829,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dea5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e61c2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3125",
    "data-name": "Rectangle 3125",
    width: 32,
    height: 32,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13699",
    "data-name": "Group 13699",
    transform: "translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13051",
    "data-name": "Path 13051",
    d: "M28,0A28,28,0,1,1,0,28,28,28,0,0,1,28,0Z",
    transform: "translate(12 12)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13698",
    "data-name": "Group 13698",
    transform: "translate(24 24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13697",
    "data-name": "Group 13697",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13057",
    "data-name": "Path 13057",
    d: "M28.436,5.909a3.9,3.9,0,1,1-3.9-3.9,3.9,3.9,0,0,1,3.9,3.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13058",
    "data-name": "Path 13058",
    d: "M17.784,10.961,15.933,8.185V3.448A3.445,3.445,0,0,0,12.485,0H3.448A3.445,3.445,0,0,0,0,3.448V8.97a3.445,3.445,0,0,0,3.448,3.448H17a.938.938,0,0,0,.78-1.457M7.94,8.9H4.98a.956.956,0,0,1-.963-.893.938.938,0,0,1,.937-.982H7.967a.937.937,0,0,1,.936.982A.955.955,0,0,1,7.94,8.9m3.039-3.515h-6A.955.955,0,0,1,4.018,4.5a.937.937,0,0,1,.936-.984h6a.954.954,0,0,1,.963.893.937.937,0,0,1-.936.982",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13059",
    "data-name": "Path 13059",
    d: "M7.28,23.259A7.357,7.357,0,0,0,0,30.644v.206A1.148,1.148,0,0,0,1.149,32H13.462a1.149,1.149,0,0,0,1.15-1.149v-.285A7.306,7.306,0,0,0,7.28,23.259",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13060",
    "data-name": "Path 13060",
    d: "M11.907,18.659a4.6,4.6,0,1,1-4.6-4.6,4.6,4.6,0,0,1,4.6,4.6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13061",
    "data-name": "Path 13061",
    d: "M30.452,15.063H18.619a5.958,5.958,0,0,1,11.833,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13062",
    "data-name": "Path 13062",
    d: "M31.063,17a.937.937,0,0,1,.936.937V29.054a.938.938,0,0,1-.983.937.956.956,0,0,1-.891-.963V27.983H16.116a9.214,9.214,0,0,0-3.865-5.149A6.474,6.474,0,0,0,13.566,17Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterview);
export default __webpack_public_path__ + "static/media/interview.3bcbf1871e27e65a8595dfb43898e162.svg";
export { ForwardRef as ReactComponent };